import { schema } from 'normalizr';
import { memberSchema } from './memberSchema';
import { leadSchema } from './leadSchema';

export const taskSchema = new schema.Entity('task', {
  accounts: [memberSchema],
  pnms: [leadSchema],
});
